module.exports = __webpack_public_path__ + "img/axe.3d747b1c.svg";